import React from 'react';
import { DefaultCard, colors, SubTitle1Text } from 'design-system';
import { Grid, Typography, makeStyles, Box } from '@material-ui/core';

// functions
import { identificationTypeString } from 'src/functions/identificationTypeString';

// Models
import FinalBeneficiary from 'src/models/helperTypes/FinalBeneficiary';

// Functions

type Props = {
  beneficiary: FinalBeneficiary;
  preventCollapse?: boolean;
};

const useStyles = makeStyles({
  fieldLabel: {
    color: colors.abbey,
    fontSize: 14,
  },
  logo: { marginRight: 11 },
});

const smallSubtitle = (
  <Typography variant="caption" style={{ color: colors.abbey }}>
    Beneficiario final con más del 10% de participación
  </Typography>
);

function mapToLabels(beneficiary: FinalBeneficiary): { [key: string]: string } {
  const { firstName, lastName, idType, id, sharePercentage } = beneficiary;
  return {
    Nombre: firstName,
    Apellido: lastName,
    'Tipo de identificacíon': identificationTypeString(idType),
    'Número de cédula o pasaporte': id,
    'Porcentaje(%) de participación': `${sharePercentage}%`,
  };
}

const BeneficiarySummaryCard = ({
  beneficiary,
  preventCollapse = false,
}: Props): JSX.Element => {
  const classes = useStyles();
  const displayData = mapToLabels(beneficiary);
  return (
    <DefaultCard
      data-testid="beneficiary-summary"
      title={
        <Grid item>
          <Box display="flex">
            <img
              src="svg/heart.svg"
              alt="heart_icon"
              className={classes.logo}
              data-testid="icon-image"
            />
            <SubTitle1Text>Datos del beneficiario final</SubTitle1Text>
          </Box>
        </Grid>
      }
      smallSubtitle={smallSubtitle}
      collapsible={!preventCollapse}
      startCollapsed
    >
      <Grid container spacing={2}>
        {Object.keys(displayData).map((key) => {
          return (
            <Grid key={`${key}`} item xs={12} md={6}>
              <Typography variant="caption" className={classes.fieldLabel}>
                {key}
              </Typography>
              <Typography variant="body2">{displayData[key]}</Typography>
            </Grid>
          );
        })}
      </Grid>
    </DefaultCard>
  );
};

export default BeneficiarySummaryCard;
